import * as React from "react";
import { Mutation } from "react-apollo";
import { Form, Label, FormGroup, Input, Button } from "reactstrap";
import Select from "react-select";

// GraphQL
import CreateRequestMutation from "../../GraphQL/Mutations/CreateRequest";

// Presentation/UI
import { LogoText } from "../../Components/Text";
import Loader from "../../Components/Loader";

// Theme
import { Colors } from "../../Themes";

// Utils
import { PRIORITIES } from "../../Utils/Consts";

interface IProps {
  customerId: any;
  notification(message: string): void;
}

class RequestForm extends React.Component<IProps> {
  state = {
    title: "",
    description: "",
    priority: null,
    loading: false,
    error: null
  };

  // Handle change
  handleChange = (e: React.FormEvent<HTMLInputElement>) => {
    const { name, value }: { name: string; value: string } = e.currentTarget;

    switch (name) {
      case "title":
        this.setState({ title: value });
        break;
      case "description":
        this.setState({ description: value });
        break;
      default:
        break;
    }
  };

  validateForm = (): boolean => {
    const { title, description } = this.state;
    // Check for undefined or empty infput fields
    if (!title || !description) {
      this.setError("Please fill in all fields");
      return false;
    }

    return true;
  };

  // Error
  setError = (error: string): void => {
    this.setState(
      {
        error
      },
      () => {
        setTimeout(() => {
          this.setState({ error: null });
        }, 3000);
      }
    );
  };

  // Select priority
  selectPriority = (priority: any) => {
    this.setState({ priority: priority.value });
  };

  render() {
    const { title, description, priority } = this.state;
    const { customerId, notification } = this.props;
    return (
      <div>
        <LogoText>maintain.</LogoText>
        <br />
        <Mutation<{}, {}> mutation={CreateRequestMutation}>
          {createRequest => (
            <Form
              onSubmit={e => {
                e.preventDefault();
                if (this.validateForm()) {
                  this.setState({ loading: true });

                  createRequest({
                    variables: {
                      customerId,
                      title,
                      description,
                      priority
                    }
                  })
                    .then(res => {
                      this.setState({
                        loading: false,
                        title: "",
                        description: "",
                        priority: null
                      });
                      notification("Your request has been sent");
                    })
                    .catch(err => {
                      this.setState({
                        loading: false
                      });
                      this.setError("There was a problem sending your request");
                    });
                }
              }}
            >
              <FormGroup>
                <Label for="title">Title</Label>
                <Input
                  type="text"
                  name="title"
                  id="title"
                  placeholder="Title"
                  onChange={this.handleChange}
                />
              </FormGroup>
              <FormGroup>
                <Label>Priority</Label>
                <Select
                  onChange={this.selectPriority}
                  options={PRIORITIES}
                  isSearchable={true}
                  placeholder="Priority"
                  className="select-styling"
                />
              </FormGroup>
              <FormGroup>
                <Label for="description">Description</Label>
                <Input
                  type="textarea"
                  name="description"
                  id="description"
                  placeholder="Description"
                  onChange={this.handleChange}
                />
              </FormGroup>
              <br />
              <FormGroup>
                <Button>
                  {!this.state.loading ? <span>Send Request</span> : <Loader />}
                </Button>
              </FormGroup>
              {this.state.error && (
                <p style={{ textAlign: "center", color: Colors.error }}>
                  {this.state.error}
                </p>
              )}
            </Form>
          )}
        </Mutation>
      </div>
    );
  }
}

export default RequestForm;



// WEBPACK FOOTER //
// ./src/Containers/CustomerRequestPortal/RequestForm.tsx